// Others.
import WebPKI from 'web-pki'
import { file, error } from '@/mixins'

export default {
    created() {
        this.pki = new WebPKI()
    },
    data: () => ({
        pki: null,
        isPkiInstalled: true,
    }),
    methods: {
        redirectToInstallPage() {

            this.pki.redirectToInstallPage()
        },
        init() {
            return new Promise((resolve, reject) => {
                this.pki.init({
                    defaultError: reject,
                    defaultFail: reject,
                    ready: resolve,
                    notInstalled: () => {

                        this.isPkiInstalled = false

                        reject({ installed: false })
                    }
                })
            })
        },
        handlePkiError(error) {

            if (typeof error === 'object' && ('installed' in error) && !error.installed) {

                this.showValidationNotification('Gerenciador de certificado não instalado!')
            }
            else {

                this.handleError(error)
            }
        },
        listCertificates(filters = {}) {
            return new Promise((resolve, reject) => {

                if (!this.isPkiInstalled) {

                    reject({ installed: false })
                }

                this.pki.listCertificates(filters).success(resolve).fail(reject)
            })
        },
        signPdf(certificateThumbprint, file) {
            return new Promise((resolve, reject) => {
                this.fileToBase64(file)
                    .then(base64 => {
                        this.pki
                            .signPdf({
                                certificateThumbprint,
                                // certificateValidationLevel: this.pki.certificateValidationLevels.offline,
                                content: base64.replace(/^data:.+;base64,/, ''),
                                output: {
                                    mode: this.pki.outputModes.returnContent,
                                },
                                policy: this.pki.padesPolicies.brazilAdrBasica,
                                visualRepresentation: {
                                    text: {
                                        text: 'Assinado eletronicamente por {{signerName}} ({{signerNationalId}})',
                                        fontSize: 8.0,
                                        includeSigningTime: true,
                                    },
                                    position: {
                                        pageNumber: -1,
                                        auto: {
                                            container: {
                                                left: 5.5,
                                                right: 1.5,
                                                bottom: 5.5,
                                                height: 15.94,
                                            },
                                            signatureRectangleSize: {
                                                height: 15.94,
                                                width: 600.0,
                                            },
                                            rowSpacing: 0.0,
                                        },
                                    },
                                }
                            })
                            .success(data => {

                                if (data.isValid) {

                                    resolve(data)
                                }
                                else {

                                    this.showValidationNotification("Certificado inválido!")

                                    reject()
                                }
                            })
                            .fail(reject)
                    })
                    .catch(reject)
            })
        },
        signWithRestPki(token, thumbprint) {
            return new Promise((resolve, reject) => {
                this.pki
                    .signWithRestPki({token, thumbprint})
                    .success(data => {
                        resolve(data)
                    })
                    .fail(reject)
            })
        },
    },
    mixins: [file, error]
}